module.exports = __webpack_public_path__ + "img/b22dfc1.jpg";